import { combineReducers } from 'redux';

import apiReducer from './common/api/apiReducer';
import formsReducer from './common/api/formsReducer';
import audioReducer from './common/audio/audioReducer';
import alexReducer from './common/alex/AlexReducer';
import avatarReducer from './common/avatar/avatarReducer';
import playlistReducer from './common/playlist/playlistReducer';
import questionsReducer from './common/questions/questionsReducer';
import timeTrackingReducer from './common/timeTracking/timeTrackingReducer';
import resultReducer from './common/api/resultReducer';
import screenReducer from './common/screen/screenReducer';
import stimulusButtonReducer from './common/stimulus/stimulusButtonReducer';
import userReducer from './common/user/userReducer';
import trcReducer from './trc/trcReducer';
import vocabReducer from './vocab/vocabReducer';
import spellingReducer from './spelling/spellingReducer';
import ranReducer from './ran/ranReducer';
import mazeReducer from './maze/mazeReducer';
import resumeReducer from './common/resume/resumeReducer';
import recordingReducer from './common/recording/recordingReducer';
import wrReducer from './wr/wrReducer';
import lcReducer from './lc/lcReducer';
import secureBrowserReducer from './common/secureBrowser/secureBrowserReducer';
import userInteractionReducer from './common/userInteraction/userInteractionReducer';

export const appReducers = {
    api: apiReducer,
    audio: audioReducer,
    alex: alexReducer,
    avatar: avatarReducer,
    playlist: playlistReducer,
    questions: questionsReducer,
    timeTracking: timeTrackingReducer,
    result: resultReducer,
    screen: screenReducer,
    stimulus: stimulusButtonReducer,
    user: userReducer,
    maze: mazeReducer,
    trc: trcReducer,
    vocab: vocabReducer,
    spelling: spellingReducer,
    ran: ranReducer,
    resume: resumeReducer,
    forms: formsReducer,
    recording: recordingReducer,
    wr: wrReducer,
    lc: lcReducer,
    secureBrowser: secureBrowserReducer,
    userInteraction: userInteractionReducer,
};

const rootReducer = combineReducers(appReducers);

export default rootReducer;
